module.exports = __webpack_public_path__ + "static/media/bmind-calendar.55b6f4c6.png";